import { levelClassificationTrd } from "utils/levelClassificationTrd";
import { enumLevelTrd } from "utils/enums";
 
 /**
   * Restructures the given data array by modifying and renaming specific properties. 
   * The function iterates over the array and restructures each object based on certain conditions,
   * adjusting properties like `id`, `parentId`, and `label`. Unnecessary properties are deleted.
   * @param {Array<Object>} data - The array of objects to be restructured. Each object should contain properties like `uuid`, `parent_id`, `name`, `code`, and `level`.
   * @returns {Array<Object>} The restructured data array.
   */
 export const reStructureData = (data) => {
  for (let i = 0; i < data.length; i++) {
    if (data[i]["code"] && data[i]["level"] !== enumLevelTrd.EXPEDIENT) {
      data[i].id = data[i]["uuid"];
      data[i].parentId = data[i]["parent_id"];
      data[i].label = `${data[i]["code"]}-${
        data[i]["name"]
      } (${levelClassificationTrd(data[i]["level"])})`;
      delete data[i].uuid;
      delete data[i].parent_id;
    } else if (data[i]["is_backend"]) {
      data[i].id = data[i]["uuid"];
      data[i].parentId = data[i]["parent_id"];
      data[i].label = `${data[i]["name"]} (${levelClassificationTrd(enumLevelTrd.BACKGROUND)})`;
      data[i].level = enumLevelTrd.BACKGROUND;
      delete data[i].uuid;
      delete data[i].parent_id;
    } else if (data[i]["level"] === enumLevelTrd.EXPEDIENT) {
      data[i].id = data[i]["uuid"];
      data[i].parentId = null;
      data[i].label = `${data[i]["name"]} (${levelClassificationTrd(
        data[i]["level"]
      )})`;
      delete data[i].uuid;
      delete data[i].parent_id;
    } else {
      data[i].id = data[i]["uuid"];
      data[i].parentId = data[i]["parent_id"];
      data[i].label = `${data[i]["name"]} (${levelClassificationTrd(
        data[i]["level"]
      )})`;
      delete data[i].uuid;
      delete data[i].parent_id;
    }
  }
  return data;
};